import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { CreateRoomSystemDto, PublicRoomSystem } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const addRoomSystem = async (
  organisationId: string,
  roomSystem: CreateRoomSystemDto,
): Promise<PublicRoomSystem> => {
  const response = await axiosClient.post(
    `/${organisationId}/room-systems`,
    roomSystem,
  );
  return response.data;
};

type AddRoomSystemData = { organisationId: string; data: CreateRoomSystemDto };

function useAddRoomSystem(
  mutationOptions?: UseMutationOptions<
    PublicRoomSystem,
    HttpError,
    AddRoomSystemData
  >,
) {
  return useMutation({
    mutationFn: (data: AddRoomSystemData) =>
      addRoomSystem(data.organisationId, data.data),
    ...mutationOptions,
  });
}

export { useAddRoomSystem };
